module.exports = __webpack_public_path__ + "static/media/Illus-LoyaltyHarvest@2x.b6330998.png";